import React from 'react';
import { useStateContext } from '../context/StateContext';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';


const StateSelector: React.FC = () => {
    const { 
        availableStates, 
        selectedState, 
        setSelectedState,
        isStateLoaded
    } = useStateContext();

    if (!isStateLoaded || availableStates.length === 0) {
        return null;
    }

    return (
        <FormControl variant="outlined" className="state-selector-form-control" size="small">
            <InputLabel id="location-select-label">Select a Location</InputLabel>
            <Select
                labelId="location-select-label"
                value={selectedState?.id?.toString() || ""}
                onChange={(e) => {
                    const value = e.target.value;
                    const state = availableStates.find(s => s.id.toString() === value);
                    if (state) {
                        setSelectedState(state);
                    }
                }}
                label="Select a Location"
            >
                {availableStates.map(state => (
                    <MenuItem key={state.id} value={state.id.toString()}>
                        {state.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default StateSelector;
